// extracted by mini-css-extract-plugin
export default {"productGallery":"cO-z","inQuickShop":"dO-z"};